import { render, staticRenderFns } from "./VsTable.vue?vue&type=template&id=2beeebbc&scoped=true&"
import script from "./VsTable.vue?vue&type=script&lang=js&"
export * from "./VsTable.vue?vue&type=script&lang=js&"
import style0 from "./VsTable.vue?vue&type=style&index=0&id=2beeebbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beeebbc",
  null
  
)

export default component.exports